import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateWorkflowNodeSlotMutationVariables = Types.Exact<{
  input: Types.CreateWorkflowNodeSlotInput;
}>;

export type CreateWorkflowNodeSlotMutation = {
  __typename?: 'Mutation';
  createWorkflowNodeSlot: {
    __typename?: 'WorkflowNodeSlot';
    id: any;
    key: string;
    dataType?: Types.SlotDataType | null;
    direction: Types.SlotDirection;
    slotType: Types.SlotType;
    optional: boolean;
    nodeId: any;
    createdAt: any;
    updatedAt: any;
  };
};

export const CreateWorkflowNodeSlotDocument = gql`
  mutation CreateWorkflowNodeSlot($input: CreateWorkflowNodeSlotInput!) {
    createWorkflowNodeSlot(input: $input) {
      id
      key
      dataType
      direction
      slotType
      optional
      nodeId
      createdAt
      updatedAt
    }
  }
`;
export type CreateWorkflowNodeSlotMutationFn = Apollo.MutationFunction<
  CreateWorkflowNodeSlotMutation,
  CreateWorkflowNodeSlotMutationVariables
>;

/**
 * __useCreateWorkflowNodeSlotMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowNodeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowNodeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowNodeSlotMutation, { data, loading, error }] = useCreateWorkflowNodeSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowNodeSlotMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateWorkflowNodeSlotMutation,
    CreateWorkflowNodeSlotMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateWorkflowNodeSlotMutation,
    CreateWorkflowNodeSlotMutationVariables
  >(CreateWorkflowNodeSlotDocument, options);
}
export type CreateWorkflowNodeSlotMutationHookResult = ReturnType<
  typeof useCreateWorkflowNodeSlotMutation
>;
export type CreateWorkflowNodeSlotMutationResult =
  Apollo.MutationResult<CreateWorkflowNodeSlotMutation>;
export type CreateWorkflowNodeSlotMutationOptions = Apollo.BaseMutationOptions<
  CreateWorkflowNodeSlotMutation,
  CreateWorkflowNodeSlotMutationVariables
>;
